import {
    REPORT_LAYOUTS_ERRORS,
    REPORT_LAYOUTS_LOADING,

    REPORT_LAYOUTS_GET,
    REPORT_LAYOUTS_GET_BY_ID,
    REPORT_LAYOUTS_INSERT,
    REPORT_LAYOUTS_UPDATE,
    REPORT_LAYOUTS_DELETE,

    REPORT_LAYOUTS_JOBS,
    REPORT_LAYOUTS_JOB_PRODUCTS
} from "api/menu/master-files/report-builder/actions";

const initialState = {
    loading: false,
    errors: [],

    reportLayouts: [],
    singleReportLayout: {},

    qlHeaders: [],
    qlHeadersSingle: {},
    qlQuestions: [],
    qlQuestionSingle: {},

    jobs: [],
    jobProducts: []
};

export default function(state = initialState, action) {
    let reportLayouts,
        index;
    switch (action.type) {
        case REPORT_LAYOUTS_ERRORS:
            return {
                ...state,
                errors: action.payload
            };
        case REPORT_LAYOUTS_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case REPORT_LAYOUTS_GET:
            return {
                ...state,
                loading: false,
                reportLayouts: action.payload
            };
        case REPORT_LAYOUTS_GET_BY_ID:
            return {
                ...state,
                loading: false,
                singleReportLayout: action.payload
            };
        case REPORT_LAYOUTS_INSERT:
            reportLayouts = Object.assign([], state.reportLayouts);
            reportLayouts.push(action.payload);
            return {
                ...state,
                loading: false,
                reportLayouts
            };
        case REPORT_LAYOUTS_UPDATE:
            reportLayouts = Object.assign([], state.reportLayouts);
            index = reportLayouts.findIndex(item => item.reportId === action.payload.reportId);
            if (index > -1) {
                reportLayouts[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                reportLayouts
            };
        case REPORT_LAYOUTS_DELETE:
            reportLayouts = Object.assign([], state.reportLayouts);
            index = reportLayouts.findIndex(item => item.reportId === action.payload);
            if (index > -1) {
                reportLayouts.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                reportLayouts
            };
        case REPORT_LAYOUTS_JOBS:
            return {
                ...state,
                loading: false,
                jobs: action.payload
            };
        case REPORT_LAYOUTS_JOB_PRODUCTS:
            return {
                ...state,
                loading: false,
                jobProducts: action.payload
            };
        default:
            return state;
    }
}
